import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  paddingLeft: "30px",
  paddingRight: "30px",
  paddingTop: "10px",
  paddingBottom: "10px",
  borderRadius: "10px",
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.background.paper}`,
  boxShadow: "25px 25px 33px rgba(0, 0, 0, 0.25)",
}));
